import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { approve } from 'scenes/FinancePage/FR/data/queryKeyFactory';
import { approveFR } from 'scenes/FinancePage/FR/sources';

export const useApprove = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(approve(), approveFR, {
    refresh: true,
    successMessage: () => `Financial Result approved`,
  });

  const handleAction = ({ id }: any) => {
    //todo add comment to confirm dialog
    confirm({
      title: `Approve Financial Result ${id}?`,
      confirmActionLabel: 'Approve',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
